import { useEffect, useState } from 'react';
export const useScreenWidth = (maxWidth) => {
    const [isBelowWidth, setIsBelowWidth] = useState(false);
    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${maxWidth}px)`);
        setIsBelowWidth(mql === null || mql === void 0 ? void 0 : mql.matches);
        const screenTest = (e) => {
            setIsBelowWidth(e === null || e === void 0 ? void 0 : e.matches);
        };
        mql === null || mql === void 0 ? void 0 : mql.addEventListener('change', screenTest);
        return () => mql === null || mql === void 0 ? void 0 : mql.removeEventListener('change', screenTest);
    }, [maxWidth]);
    return isBelowWidth;
};
